import {
  computed, ref,
} from '@vue/composition-api';

export const tokenName = 'panicom-ai-token';

const isAttemptedCheck = ref(false);

export default function useAuth() {
  function hasPermission(me: any, permName: string) {
    // TODO: separate '*' (for ideavivat) and 'dotify.*' (for super admin)
    return computed(() => {
      if (!(me.roles)) return false;
      const permArr = me.roles[0]?.permissions.map((p: any) => p.name);
      if (permArr.indexOf('*') === 0) return true;
      if (permArr.indexOf(permName) !== -1) return true;
      if (permName.indexOf('.any') !== -1) return permArr.find((perm: string) => perm.indexOf(permName.replace('.any', '')) > -1) !== undefined;
      return false;
    }).value;
  }

  return {
    hasPermission,
    isAttemptedCheck,
  };
}
